module.exports = __webpack_public_path__ + "img/website-service-06.c8558573.png";